import { Navigate, Route, Routes } from "react-router-dom";
import { AdminAuthProvider } from "../../app/AdminAuthContext";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import ProtectedRoute from "./ProtectedRoute";
import TreatmentsAdmin from "./TreatmentsAdmin";
import StaffAdmin from "./StaffAdmin";
import HearingAidSuppliersAdmin from "./HearingAidSuppliersAdmin";
import AppointmentInfoAdmin from "./AppointmentInfoAdmin";
import SiteContentAdmin from "./SiteContentAdmin";

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Navigate to="treatments" replace />} />
            <Route path="treatments" element={<TreatmentsAdmin />} />
            <Route path="staff" element={<StaffAdmin />} />
            <Route
              path="hearing-aid-suppliers"
              element={<HearingAidSuppliersAdmin />}
            />
            <Route path="appointment-info" element={<AppointmentInfoAdmin />} />
            <Route path="site-content" element={<SiteContentAdmin />} />
          </Route>
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}
